import { Link, NavLink, Outlet } from 'react-router-dom'

const SUBTABS: Array<{ to: string; label: string; end?: boolean }> = [
  { to: '', label: 'Requests', end: true },
  { to: 'receipts', label: 'Receipts' },
]

export function ProjectMaterialsTab() {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-1">
          {SUBTABS.map((t) => (
            <NavLink
              key={t.label}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-md text-sm ${
                  isActive
                    ? 'bg-accent-500/10 text-accent-400'
                    : 'text-surface-400 hover:text-surface-100'
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </div>
        <Link to="/materials" className="text-xs text-surface-400 hover:text-accent-400">
          View catalog →
        </Link>
      </div>
      <Outlet />
    </div>
  )
}
